import { getOwnerPage } from 'src/hooks/block/use-get-owner-page';
import { getSortedRecordIds } from 'src/hooks/collection-view/use-get-sorted-records';
import type { UIState } from 'src/redux/reducers/ui';
import { cache } from 'src/redux/store';
import { getDynamicPageId } from './getPageId';
import { getAllExpandIds } from 'src/hooks/block/use-open-subitem';

/** 解析选中的cell,返回从上到下的recordIndex，从左到右的propertyIndex */

export const parseSelectedCells = (selectedCells: UIState['selectedCells']) => {
  const focusedCell = selectedCells[0];
  const lastSelectedCell = selectedCells[selectedCells.length - 1];
  if (!focusedCell || !lastSelectedCell) {
    return;
  }
  const collectionBlockId = getOwnerPage(focusedCell.recordId);
  if (!collectionBlockId) {
    return;
  }
  const collectionBlock = cache.blocks[collectionBlockId];
  if (!collectionBlock) {
    return;
  }
  const { viewId } = lastSelectedCell;
  if (!viewId) {
    return;
  }
  // 把cell内容放到剪切板，每条record占用一行，按左上到右下的顺序放置
  const propertyIds = cache.collectionViews[viewId]?.format.tableProperties
    ?.filter((property) => property.visible)
    .map((item) => item.property);

  if (!propertyIds) {
    return;
  }

  let { sortedRecordIds } = getSortedRecordIds({
    viewId,
    groupValue: focusedCell.groupValue,
    pageId: getDynamicPageId(),
    openSubItem: true,
  });
  const collectionId = cache.blocks[focusedCell.recordId]?.parentId ?? '';
  sortedRecordIds = getAllExpandIds(collectionId, viewId, sortedRecordIds);
  const focusRecordIndex = sortedRecordIds.indexOf(focusedCell.recordId);
  const lastSelectedRecordIndex = sortedRecordIds.indexOf(lastSelectedCell.recordId);
  const isTopToBottom = focusRecordIndex <= lastSelectedRecordIndex;
  const topRecordIndex = isTopToBottom ? focusRecordIndex : lastSelectedRecordIndex;
  const bottomRecordIndex = isTopToBottom ? lastSelectedRecordIndex : focusRecordIndex;

  const focusCellPropertyIndex = propertyIds.indexOf(focusedCell.propertyId);
  const lastSelectedCellPropertyIndex = propertyIds.indexOf(lastSelectedCell.propertyId);
  const isLeftToRight = focusCellPropertyIndex <= lastSelectedCellPropertyIndex;
  const leftPropertyIndex = isLeftToRight ? focusCellPropertyIndex : lastSelectedCellPropertyIndex;
  const rightPropertyIndex = isLeftToRight ? lastSelectedCellPropertyIndex : focusCellPropertyIndex;
  return {
    topRecordIndex,
    bottomRecordIndex,
    leftPropertyIndex,
    rightPropertyIndex,
    sortedRecordIds,
    propertyIds,
  };
};
